const ra_language_english = {
    ra: {
        action: {
            add_filter: 'Add filter',
            add: 'New',
            back: 'Back',
            bulk_actions: 'One item selected |||| %{smart_count} items selected',
            cancel: 'Cancel',
            clear_input_value: 'Clear input value',
            clone: 'Clone',
            confirm: 'Confirm',
            create: 'Create',
            create_item: 'Create %{item}',
            delete: 'Delete',
            edit: 'Edit',
            export: 'Export',
            list: 'List',
            refresh: 'Refresh',
            remove_filter: 'Remove filter',
            remove: 'Remove',
            save: 'Save',
            search: 'Search',
            show: 'Show',
            sort: 'Sort',
            undo: 'Undo',
            unselect: 'Unselect',
            expand: 'Expand',
            close: 'Close',
            open_menu: 'Open menu',
            close_menu: 'Close menu'
        },
        sort: {sort_by: 'Sort by %{field} %{order}', ASC: 'ascending', DESC: 'descending'},
        boolean: {
            true: 'Yes',
            false: 'No',
            null: '',
        },
        page: {
            create: 'Create %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Something went wrong',
            list: '%{name}',
            loading: 'Page is loading.',
            not_found: 'Not found',
            show: '%{name} #%{id}',
            empty: 'No %{name} yet.',
            invite: 'Create new?',
        },
        input: {
            file: {
                upload_several: 'Drop files to upload, or click to select files.',
                upload_single: 'Drop a file to upload, or click to select a file.',
            },
            image: {
                upload_several: 'Drop images to upload, or click to select images.',
                upload_single: 'Drop an image to upload, or click to select an image.',
            },
            references: {
                all_missing: 'Could not find referenced items.',
                many_missing: 'At least one of the referenced items appears to be unavailable.',
                single_missing: 'A referenced item appears to be unavailable.',
            },
            password: {
                toggle_visible: 'Hide password',
                toggle_hidden: 'Show password',
            },
        },
        message: {
            about: 'About',
            are_you_sure: 'Are you sure?',
            bulk_delete_content: 'Are you sure you want to delete "%{name}"? |||| Are you sure you want to delete these %{smart_count} items?',
            bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name} items',
            delete_content: 'Are you sure you want to delete this item?',
            delete_title: 'Delete %{name} #%{id}',
            details: 'Details',
            error: 'An error occurred and your request could not be completed.',
            invalid_form: 'The form is invalid. Please check your input.',
            loading: 'The page is loading, please be patient.',
            no: 'No',
            not_found: 'The page could not be found.',
            yes: 'Yes',
            unsaved_changes: 'Some changes are unsaved. Are you sure you want to leave this page?',
        },
        navigation: {
            no_results: 'No results found',
            no_more_results: 'Page %{page} has no content.',
            page_out_of_boundaries: 'Page %{page} is out of boundaries',
            page_out_from_end: 'Last page',
            page_out_from_begin: 'First page',
            page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
            page_rows_per_page: 'Rows per page:',
            next: 'Next',
            prev: 'Previous',
            skip_nav: 'Skip to content',
        },
        auth: {
            auth_check_error: 'Please sign in to continue',
            user_menu: 'Profile',
            username: 'Email address',
            password: 'Password',
            sign_in: 'Sign in',
            sign_in_error: 'Sign in error',
            logout: 'Logout',
        },
        notification: {
            updated: 'Item updated |||| %{smart_count} items updated',
            created: 'Item created',
            deleted: 'Item deleted |||| %{smart_count} items deleted',
            bad_item: 'Bad item',
            item_doesnt_exist: 'Item does not exist',
            http_error: 'Error communicating with server',
            data_provider_error: 'Error in dataProvider. Check console for details.',
            i18n_error: 'Translations for the selected language cannot be loaded.',
            canceled: 'Action canceled',
            logged_out: 'Your session has ended, please sign in again.',
        },
        validation: {
            required: 'Required',
            minLength: 'Must be at least %{min} characters',
            maxLength: 'Must be %{max} characters or less',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Must be a number',
            email: 'Must be a valid email',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match the following pattern: %{pattern}',
        },
    },
};

export default ra_language_english;


